document.addEventListener('DOMContentLoaded', () => {
  const upsellSection = document.querySelector('.cart-upsell-section');
  const upsellProducts = document.querySelectorAll('.upsell-product');

  fetch('/cart.js', {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' }
  })
    .then(response => response.json())
    .then(cart => {
      const cartItems = new Set(cart.items.map(item => item.variant_id));

      upsellProducts.forEach(product => {
        const variantId = Number(product.querySelector('.upsell-add-to-cart')?.dataset.variantId);
        if (variantId && cartItems.has(variantId)) {
          product.style.display = 'none';
        }
      });

      const visibleUpsellProducts = Array.from(upsellProducts).some(
        product => product.style.display !== 'none'
      );

      if (!visibleUpsellProducts) {
        upsellSection.style.display = 'none';
      }
    })
    .catch(() => {});

  document.querySelectorAll('.upsell-add-to-cart').forEach(button => {
    button.addEventListener('click', (event) => {
      event.preventDefault();

      const variantId = button.dataset.variantId;
      if (!variantId) return;

      const originalText = button.textContent;
      button.textContent = 'Adding...';
      button.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: Number(variantId), quantity: 1 })
      })
        .then(response => response.json())
        .then(() => {
          location.reload();
        })
        .catch(() => {
          button.textContent = originalText;
          button.disabled = false;
        });
    });
  });
});
